export class FilterBase {
        
    public search:string
    
    constructor({search = "" ,ongoing=false}= {}) {        
        this.search = search
    }
}
